import type { FC } from "preact/compat";
import type { ButtonProps } from "./interfaces";
import cn from "classnames";

const Button: FC<ButtonProps> = ({
    className,
    children,
    type = "button",
    ...rest
}) => (
    <button
        type={type}
        className={cn(
            "select-none transition duration-100 flex items-center disabled:text-gray-400 disabled:pointer-events-none",
            "border rounded-3xl px-4 py-1 border-gray-300",
            "hover:text-sky-500 hover:border-sky-500",
            "outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 focus:ring-offset-white",
            className && String(className)
        )}
        {...rest}
    >
        {children}
    </button>
);

export default Button;
